import { FormControl } from '@angular/forms';
import { DataLayerService } from '../../services/utils/data-layer.service';
import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../services/api.service';
import { AuthService } from '../../abstraction/auth.service';
import { PaginatorData } from './paginator/paginator.component';
import { saveAs } from 'file-saver';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.scss'],
})
export class HistoryComponent implements OnInit {
  monthOperations: [number, number];
  activities: any[];
  currentPageActivities: any[] = [];
  loadingHistories = Array(15).fill(0);
  showLoadingHistories = true;
  disablePaginationButtons = true;
  loadingFile = false;

  constructor(
    public authService: AuthService,
    public data: DataLayerService,
    public api: ApiService,
    private titleService: Title,
  ) {}

  ngOnInit() {
    this.titleService.setTitle('TiendaCrypto | Historial');
    this.authService.sendTikTokPageView(window.location.href).subscribe();
    if (this.authService.loggedUser) {
      this.updateBenefitsData();
    }
    if (!this.authService.historyLoaded || this.authService.historyPagination.page !== 1) {
      this.authService.historyPagination = { limit: 10, page: 1 };
      this.authService
        .getUserHistories(
          this.authService.historyPagination.page,
          this.authService.historyPagination.limit,
        )
        .subscribe(() => {
          setTimeout(() => {
            this.disablePaginationButtons = false;
            this.showLoadingHistories = false;
          }, 1000);
        });
    } else {
      this.showLoadingHistories = false;
      this.disablePaginationButtons = false;
    }
    this.authService.userActivities.subscribe((res) => {
      this.activities = res;
      this.monthOperations = [0, 0];
      if (!this.authService.loggedUser) {
        return;
      }
      this.monthOperations[0] = this.authService.loggedUser.orders
        .filter(
          (a) =>
            a.destCoin === 0 &&
            new Date(a.creationTime).getMonth() === new Date().getMonth() &&
            new Date(a.creationTime).getFullYear() === new Date().getFullYear() &&
            a.status === 1,
        )
        .reduce((prev, curr) => {
          let amount = prev;
          if (curr.market) {
            amount += curr.amount;
          } else {
            if (curr.origAmount) {
              amount += curr.origAmount / curr.coinValue;
            } else {
              amount += curr.amount / curr.coinValue;
            }
          }
          return amount;
        }, 0);
      this.monthOperations[1] = this.authService.loggedUser.orders
        .filter(
          (a) =>
            a.destCoin === 1 &&
            new Date(a.creationTime).getMonth() === new Date().getMonth() &&
            new Date(a.creationTime).getFullYear() === new Date().getFullYear() &&
            a.status === 1,
        )
        .reduce((prev, curr) => {
          let amount = prev;

          amount += curr.amount * curr.coinValue;

          return amount;
        }, 0);
    });
  }

  updateBenefitsData() {
    // this.authService.getReferralBenefits();
    this.authService.sortActivitiesAndOrders();
  }

  imgErrorHandler(event: any, activity: any) {
    event.target.src = '/assets/icons/crypto/' + activity.srcCoin.toLowerCase() + '.svg';
  }

  handlePaginationChange(event: PaginatorData) {
    this.disablePaginationButtons = true;
    this.authService.getUserHistories(event.page, event.limit).subscribe((res) => {
      this.disablePaginationButtons = false;
      if (
        res.bundleOrders.length ||
        res.cryptoTxs.length ||
        res.deposits.length ||
        res.orders.length ||
        res.withdraws.length ||
        res.payroll.length
      ) {
        this.authService.historyPagination = event;
      } else if (this.authService.historyPagination.page != 1) {
        this.authService.historyPagination.page = 1;
        this.authService.getUserHistories(
          this.authService.historyPagination.page,
          this.authService.historyPagination.limit,
        );
      }
    });
  }

  downloadHistory() {
    this.loadingFile = true;
    this.authService.downloadHistory().subscribe({
      next: (data) => {
        const blob = new Blob([data], { type: 'text/csv' });
        saveAs(blob, 'operaciones.csv');
        this.loadingFile = false;
      },
      error: (error) => {
        console.log(error);
        this.loadingFile = false;
      },
    });
  }
}
